export default __webpack_public_path__ + "static/media/science.01bd7fd6.png";